import CopyrightFooter from '../footer/Footer'
import NavBar from '../navBar/NavBar'
import HowItWorks from './HowItWorks';

function HowItWorksContainer(){
    return (
        <>
            <NavBar />
            <HowItWorks />
            <CopyrightFooter />
        </>
    )
}

export default HowItWorksContainer;
